import React, { useState } from "react";
import { Table, Grid, Card, Pagination } from "antd";

const { useBreakpoint } = Grid;

const ResponsiveTable = ({ columns, dataSource, rowKey, pagination }) => {
    const screens = useBreakpoint();
    const isMobile = !screens.md;

    const pageSize = pagination?.pageSize || 20;
    const [currentPage, setCurrentPage] = useState(1);
    const [expanded, setExpanded] = useState({});

    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;

    const pageData = dataSource.slice(start, end);

    const toggleExpand = (key, field) => {
        const id = `${key}_${field}`;
        setExpanded((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    // Desktop normal table
    if (!isMobile) {
        return (
            <Table
                columns={columns}
                dataSource={dataSource}
                rowKey={rowKey}
                pagination={pagination}
                onChange={(page) => {
                    setCurrentPage(page);

                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }}
                scroll={{ x: 1000 }}
            />
        );
    }

    // Mobile card layout
    return (
        <div className="mobile-table">
            {pageData.map((record) => (
                <Card key={record[rowKey]} className="mobile-card">

                    {columns.map((col, index) => {

                        let value;

                        if (col.render) {
                            value = col.render(record[col.dataIndex], record);
                        } else if (col.dataIndex) {
                            value = record[col.dataIndex];
                        }

                        if (!value) return null;

                        const textValue = typeof value === "string" ? value : null;

                        const id = `${record[rowKey]}_${col.dataIndex}`;

                        const isLong =
                            textValue && textValue.length > 60;

                        const displayText =
                            isLong && !expanded[id]
                                ? textValue.substring(0, 60) + "..."
                                : textValue;

                        return (
                            <div key={index} className="mobile-row">

                                <strong>{col.title}</strong>

                                <div className="mobile-value">

                                    {textValue ? displayText : value}

                                    {isLong && (
                                        <div
                                            className="view-more"
                                            onClick={() =>
                                                toggleExpand(record[rowKey], col.dataIndex)
                                            }
                                        >
                                            {expanded[id] ? "View Less" : "View More"}
                                        </div>
                                    )}

                                </div>

                            </div>
                        );
                    })}

                </Card>
            ))}
            <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={dataSource.length}
                onChange={(page) => {
                    setCurrentPage(page);

                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }}
                style={{ textAlign: "center", marginTop: 20 }}
            />
        </div>
    );
};

export default ResponsiveTable;